import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/store';
import { Textbaustein, Vorlage, VorlageItem } from '@/models/VorlageModels';
import { PagedResult } from '@/models/CommonModels';

export type Getters = {
  vorlagen(state: State): Array<Vorlage>;
  vorlagenItems(state: State): Array<VorlageItem>;
  vorlagePage(state: State): PagedResult<VorlageItem>;
  textbausteine(state: State): Array<Textbaustein>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  vorlagen(state: State) {
    return state.vorlagen;
  },

  vorlagenItems(state: State) {
    return state.vorlageItems;
  },

  vorlagePage(state: State) {
    return state.vorlagePage;
  },

  textbausteine(state: State) {
    return state.textbausteine;
  },
};
